import {RouteLocationNormalized, RouteRecordRaw, createRouter, createWebHistory} from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import PicklistList from '@/views/Picklist/PicklistList.vue';
import PicklistDetail from '@/views/Picklist/PicklistDetail.vue';
import OrderList from '@/views/Order/OrderList.vue';
import InventoryList from '@/views/Inventory/InventoryList.vue';
import InventoryCreate from '@/views/Inventory/InventoryCreate.vue';
import InventoryPick from '@/views/Inventory/InventoryPick.vue';
import OrderDelivery from '@/views/Order/OrderDelivery.vue';
import OrderPick from '@/views/Order/OrderPick.vue';
import SuggestionList from '@/views/Suggestion/SuggestionList.vue';
import SuggestionCreate from '@/views/Suggestion/SuggestionCreate.vue';
import SuggestionPick from '@/views/Suggestion/SuggestionPick.vue';
import ArticleList from '@/views/Article/ArticleList.vue';
import Settings from '@/views/Settings.vue';
import Module from '@/views/Module.vue';
import Login from '@/views/Login.vue';
import ChangePassword from '@/views/ChangePassword.vue';
import Followup from '@/views/Followup/Followup.vue';
import CRMDashboard from '@/views/CRM/CRMDashboard.vue';
import CustomerList from '@/views/CRM/Customer/CustomerList.vue';
import CustomerNearbyList from '@/views/CRM/Customer/CustomerNearbyList.vue';
import CustomerDetails from '@/views/CRM/Customer/CustomerDetails.vue';
import CustomerDocuments from '@/views/CRM/Customer/CustomerDocuments.vue';
import CustomerDocumentCreate from '@/views/CRM/Customer/CustomerDocumentCreate.vue';
import ContactList from '@/views/CRM/Customer/Contact/ContactList.vue';
import ContactDetailsVue from '@/views/CRM/Customer/Contact/ContactDetails.vue';
import ContactCreateVue from '@/views/CRM/Customer/Contact/ContactCreate.vue';
import ContactHistoryList from '@/views/CRM/Customer/ContactHistory/ContactHistoryList.vue';
import ContactHistoryDetails from '@/views/CRM/Customer/ContactHistory/ContactHistoryDetails.vue';
import ContactHistoryDocumentCreate from '@/views/CRM/Customer/ContactHistory/ContactHistoryDocumentCreate.vue';
import ContactHistoryCreate from '@/views/CRM/Customer/ContactHistory/ContactHistoryCreate.vue';
import TaskList from '@/views/CRM/Customer/Processes/TaskList.vue';
import TaskDetails from '@/views/CRM/Customer/Processes/TaskDetails.vue';
import OfferList from '@/views/CRM/Customer/Processes/OfferList.vue';
import OfferDetails from '@/views/CRM/Customer/Processes/OfferDetails.vue';
import BillList from '@/views/CRM/Customer/Processes/BillList.vue';
import BillDetails from '@/views/CRM/Customer/Processes/BillDetails.vue';
import CRMOrderList from '@/views/CRM/Customer/Processes/OrderList.vue';
import CRMOrderDetails from '@/views/CRM/Customer/Processes/OrderDetails.vue';
import DeliveryNoteList from '@/views/CRM/Customer/Processes/DeliveryNoteList.vue';
import DeliveryNoteDetails from '@/views/CRM/Customer/Processes/DeliveryNoteDetails.vue';
import FilterPicklist from '@/components/Filter/FilterPicklist.vue';
import FilterOrder from '@/components/Filter/FilterOrder.vue';
import FilterInventory from '@/components/Filter/FilterInventory.vue';
import FilterSuggestion from '@/components/Filter/FilterSuggestion.vue';
import FilterProvider from '@/components/Filter/FilterProvider.vue';
import FilterContact from '@/components/Filter/FilterContact.vue';
import FilterContactHistory from '@/components/Filter/FilterContactHistory.vue';
import FilterFollowup from '@/components/Filter/FilterFollowup.vue';
import FilterNearbyProvider from '@/components/Filter/FilterNearbyProvider.vue';
import FilterDeliveryNote from '@/components/Filter/FilterDeliveryNote.vue';
import FilterTask from '@/components/Filter/FilterTask.vue';
import FilterOffer from '@/components/Filter/FilterOffer.vue';
import FilterBill from '@/components/Filter/FilterBill.vue';
import FilterCrmOrder from '@/components/Filter/FilterCrmOrder.vue';
import {Settings as SetSettings, useSettings} from '@/store/settings';
import {useApplicationState} from '@/store/applicationState';
import pinia from '@/plugins/pinia';
import CustomerInteressentCreate from '@/views/CRM/Customer/CustomerInteressentCreate.vue';
import {useFollowupCountStore} from '@/store/followupCount';
import ArticleDetail from '@/views/Article/ArticleDetail.vue';
import ContactHistoryEmail from '@/views/CRM/Customer/ContactHistory/ContactHistoryEmail.vue';
import BestandskorrekturCreate from '@/views/Corrections/CorrectionsCreate.vue';
import BestandskorrekturList from '@/views/Corrections/CorrectionsList.vue';
import BestandskorrekturPick from '@/views/Corrections/CorrectionsPick.vue';
import UmbuchungList from '@/views/Umbuchung/UmbuchungList.vue';
import FilterUmbuchung from '@/components/Filter/FilterUmbuchung.vue';
import UmbuchungCreate from '@/views/Umbuchung/UmbuchungCreate.vue';
import UmbuchungPick from '@/views/Umbuchung/UmbuchungPick.vue';
import FilterCorrection from '@/components/Filter/FilterCorrection.vue';
import PicklistCreate from '@/views/Picklist/PicklistCreate.vue';
const routes: RouteRecordRaw[] = [
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      title: 'Anmelden',
      allowUnauthenticated: true,
      hideInNav: true,
    },
  },
  {
    name: 'dashboard',
    path: '/',
    component: Dashboard,
    meta: {
      title: 'Dashboard',
      icon: 'mdi-view-dashboard',
    },
  },
  {
    name: 'crm',
    path: '/crm',
    component: Module,
    redirect: {
      name: 'crm_dashboard',
    },
    meta: {
      title: 'CRM',
      desc: 'Kunden-Übersicht',
      icon: 'mdi-monitor-dashboard',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_CRM;
      },
    },
    children: [
      {
        path: 'dashboard',
        name: 'crm_dashboard',
        component: CRMDashboard,
        meta: {
          title: 'CRM',
          desc: 'Kunden, Interessenten, Lieferanten',
          icon: 'mdi-piggy-bank',
        },
      },
      {
        path: 'customer',
        name: 'customer_module',
        component: Module,
        meta: {
          title: 'Firmen',
          canGoBack: true,
          icon: 'mdi-account-group',
        },
        redirect: {
          name: 'customer_list',
        },
        children: [
          {
            path: 'list',
            name: 'customer_list',
            meta: {
              canGoBack: true,
              filter: FilterProvider,
              neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
            },
            component: CustomerList,
          },
          {
            path: 'createinteressent',
            name: 'customer_interessent_create',
            meta: {
              canGoBack: true,
            },
            component: CustomerInteressentCreate,
          },
          {
            path: 'nearby',
            name: 'customer_nearby_list',
            meta: {
              canGoBack: true,
              filter: FilterNearbyProvider,
              neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
            },
            component: CustomerNearbyList,
          },
          {
            path: ':id',
            name: 'customer_details_module',
            redirect: (to: RouteLocationNormalized) => {
              return {name: 'customer_details', params: {id: to.params.id}};
            },
            component: Module,
            meta: {
              title: 'Kundendetails',
              canGoBack: true,
              icon: 'mdi-account-group',
            },
            children: [
              {
                path: 'details',
                name: 'customer_details',
                component: CustomerDetails,
                meta: {
                  title: 'Kundendetails',
                  canGoBack: true,
                  icon: 'mdi-account-group',
                  neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                },
              },
              {
                path: 'documents',
                name: 'customer_documents',
                component: CustomerDocuments,
                meta: {
                  title: 'Dokumente',
                  canGoBack: true,
                },
              },
              {
                path: 'documents/create',
                name: 'customer_document_create',
                component: CustomerDocumentCreate,
                meta: {
                  title: 'Dokument Anlegen',
                  canGoBack: true,
                },
              },
              {
                path: 'delivery_notes',
                name: 'customer_delivery_notes_module',
                component: Module,
                redirect: {
                  name: 'customer_delivery_notes_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'customer_delivery_notes_list',
                    component: DeliveryNoteList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterDeliveryNote,
                    },
                  },
                  {
                    path: ':delivery_note_id',
                    name: 'customer_delivery_note_details',
                    component: DeliveryNoteDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'bills',
                name: 'customer_bills_module',
                component: Module,
                redirect: {
                  name: 'customer_bills_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'customer_bills_list',
                    component: BillList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterBill,
                    },
                  },
                  {
                    path: ':bill_id',
                    name: 'customer_bill_details',
                    component: BillDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'orders',
                name: 'customer_orders_module',
                component: Module,
                redirect: {
                  name: 'customer_orders_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'customer_orders_list',
                    component: CRMOrderList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterCrmOrder,
                    },
                  },
                  {
                    path: ':order_id',
                    name: 'customer_order_details',
                    component: CRMOrderDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'tasks',
                name: 'customer_tasks_module',
                component: Module,
                redirect: {
                  name: 'customer_tasks_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'customer_tasks_list',
                    component: TaskList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterTask,
                    },
                  },
                  {
                    path: ':task_id',
                    name: 'customer_task_details',
                    component: TaskDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'offers',
                name: 'customer_offers_module',
                component: Module,
                redirect: {
                  name: 'customer_offers_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'customer_offers_list',
                    component: OfferList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterOffer,
                    },
                  },
                  {
                    path: ':offer_id',
                    name: 'customer_offer_details',
                    component: OfferDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'contacthistories',
                name: 'contact_histories_module',
                component: Module,
                redirect: {
                  name: 'contact_histories_list',
                },
                children: [
                  {
                    path: 'list',
                    name: 'contact_histories_list',
                    component: ContactHistoryList,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                      filter: FilterContactHistory,
                    },
                  },
                  {
                    path: 'create',
                    name: 'contact_history_create',
                    component: ContactHistoryCreate,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                  {
                    path: ':contact_history_id/edit',
                    name: 'contact_history_edit',
                    component: ContactHistoryCreate,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                  {
                    path: ':contact_history_id',
                    name: 'contact_histories_details',
                    component: ContactHistoryDetails,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                  {
                    path: ':contact_history_id/email/:email_id',
                    name: 'contact_histories_email',
                    component: ContactHistoryEmail,
                    meta: {
                      canGoBack: true,
                      title: 'E-Mail',
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                  {
                    path: ':contact_history_id/document/create',
                    name: 'contact_histories_document_create',
                    component: ContactHistoryDocumentCreate,
                    meta: {
                      canGoBack: true,
                      neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                    },
                  },
                ],
              },
              {
                path: 'contacts',
                name: 'customer_contacts_list',
                component: ContactList,
                meta: {
                  filter: FilterContact,
                  title: 'Kunde Ansprechpartner',
                  canGoBack: true,
                  icon: 'mdi-account',
                  neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                },
              },
              {
                path: 'contacts/create/:contact_id?',
                name: 'customer_contact_create',
                component: ContactCreateVue,
                meta: {
                  canGoBack: true,
                },
              },
              {
                path: 'contacts/:contact_id',
                name: 'customer_contact_details',
                component: ContactDetailsVue,
                meta: {
                  title: 'Ansprechpartnerdetails',
                  canGoBack: true,
                  icon: 'mdi-account',
                  neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/follow-up',
    name: 'followup_module',
    component: Module,
    redirect: {
      name: 'followup',
    },
    meta: {
      title: 'Wiedervorlage',
      desc: 'Wiedervorlage',
      icon: 'mdi-phone-sync-outline',
      get badgeContent() {
        const count = useFollowupCountStore().followupCount;
        if (count > 99) return '99+';

        return count;
      },
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_CRM;
      },
    },
    children: [
      {
        path: 'list',
        name: 'followup',
        component: Followup,
        meta: {
          title: 'Wiedervorlage',
          desc: 'Wiedervorlage',
          module: 'followups',
          canGoBack: false,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          filter: FilterFollowup,
        },
      },
    ],
  },
  {
    name: 'picklist',
    path: '/picklist',
    component: Module,
    redirect: {
      name: 'picklist_list',
    },
    meta: {
      title: 'Warenausgang',
      desc: 'Picklisten bearbeiten',
      icon: 'mdi-truck-delivery',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'picklist_list',
        component: PicklistList,
        meta: {
          title: 'Warenausgang',
          filter: FilterPicklist,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'picklists',
        },
      },
      {
        path: 'create',
        name: 'picklist_create',
        component: PicklistCreate,
        meta: {
          canGoBack: true,
          title: 'Pickliste erstellen',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: ':id',
        name: 'picklist_detail',
        component: PicklistDetail,
        meta: {
          title: 'Pickliste',
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'order',
    path: '/order',
    component: Module,
    redirect: {
      name: 'order_list',
    },
    meta: {
      title: 'Wareneingang',
      desc: 'Wareneingang verwalten',
      icon: 'mdi-truck-check',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'order_list',
        component: OrderList,
        meta: {
          title: 'Wareneingang',
          filter: FilterOrder,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'orders',
        },
      },
      {
        path: 'delivery/:id?',
        name: 'order_delivery',
        component: OrderDelivery,
        meta: {
          canGoBack: true,
          title: 'Lieferung erstellen',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: 'pick',
        name: 'order_pick',
        component: OrderPick,
        meta: {
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'inventory',
    path: '/inventory',
    component: Module,
    redirect: {
      name: 'inventory_list',
    },
    meta: {
      title: 'Inventur',
      desc: 'Inventuren verwalten',
      icon: 'mdi-clipboard-check',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'inventory_list',
        component: InventoryList,
        meta: {
          filter: FilterInventory,
          title: 'Inventur',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'inventories',
        },
      },
      {
        path: 'create/:id?',
        name: 'inventory_create',
        component: InventoryCreate,
        meta: {
          canGoBack: true,
          title: 'Inventur erstellen',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: 'pick',
        name: 'inventory_pick',
        component: InventoryPick,
        meta: {
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'suggestion',
    path: '/suggestion',
    component: Module,
    redirect: {
      name: 'suggestion_list',
    },
    meta: {
      title: 'Bestellvorschlag',
      desc: 'Bestellvorschläge verwalten',
      icon: 'mdi-cart',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'suggestion_list',
        component: SuggestionList,
        meta: {
          filter: FilterSuggestion,
          title: 'Bestellvorschlag',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'suggestions',
        },
      },
      {
        path: 'create/:id?',
        name: 'suggestion_create',
        component: SuggestionCreate,
        meta: {
          canGoBack: true,
          title: 'Bestellvorschlag',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: 'pick',
        name: 'suggestion_pick',
        component: SuggestionPick,
        meta: {
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'correction',
    path: '/correction',
    component: Module,
    redirect: {
      name: 'correction_list',
    },
    meta: {
      title: 'Bestandskorrektur',
      desc: 'Bestand korrigieren',
      icon: 'mdi-archive-edit',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'correction_list',
        component: BestandskorrekturList,
        meta: {
          filter: FilterCorrection,
          title: 'Bestandskorrektur',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'corrections',
        },
      },
      {
        path: 'create/:id?',
        name: 'correction_create',
        component: BestandskorrekturCreate,
        meta: {
          canGoBack: true,
          title: 'Bestandskorrektur',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'corrections',
        },
      },
      {
        path: 'pick',
        name: 'correction_pick',
        component: BestandskorrekturPick,
        meta: {
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'corrections',
        },
      },
    ],
  },
  {
    name: 'umbuchung',
    path: '/umbuchung',
    component: Module,
    redirect: {
      name: 'umbuchung_list',
    },
    meta: {
      title: 'Lager zu Lager',
      desc: 'Lager zu Lager Buchungen verwalten',
      icon: 'mdi-swap-horizontal',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'umbuchung_list',
        component: UmbuchungList,
        meta: {
          filter: FilterUmbuchung,
          title: 'Lager zu Lager',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
          module: 'umbuchungen',
        },
      },
      {
        path: 'create/:id?',
        name: 'umbuchung_create',
        component: UmbuchungCreate,
        meta: {
          canGoBack: true,
          title: 'Neue Buchung',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: 'pick',
        name: 'umbuchung_pick',
        component: UmbuchungPick,
        meta: {
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'userShort', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'article',
    path: '/article-info',
    component: Module,
    redirect: {
      name: 'article_info_list',
    },
    meta: {
      title: 'Artikel-Info',
      desc: 'Artikel-Informationen erhalten',
      icon: 'mdi-warehouse',
      get hideInNav() {
        const authStore = useSettings();
        return !authStore.licenses.L3_APP_LAGER;
      },
    },
    children: [
      {
        path: 'list',
        name: 'article_info_list',
        component: ArticleList,
        meta: {
          title: 'Artikel-Info',
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
      {
        path: ':id',
        name: 'article_info_detail',
        component: ArticleDetail,
        meta: {
          title: 'Artikel-Info',
          canGoBack: true,
          neededSettings: ['selectedWarehouse', 'selectedSubsidiary', 'client'] satisfies Array<keyof SetSettings>,
        },
      },
    ],
  },
  {
    name: 'settings',
    path: '/settings',
    component: Settings,
    meta: {
      title: 'Einstellungen',
      icon: 'mdi-cog',
    },
  },
  {
    name: 'changePassword',
    path: '/change-password',
    component: ChangePassword,
    meta: {
      title: 'Passwort ändern',
      icon: 'mdi-key',
    },
  },
];

export {routes};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({left: 0, top: 0}),
});

router.beforeEach(async (to, from, next) => {
  const applicationState = useApplicationState(pinia);
  applicationState.updateTitle(null);
  applicationState.wantsRoute(to);

  // nicht angemeldet + nicht auf Login => auf Login weiterleiten
  if (applicationState.blockedByLogin && to.name !== 'login') {
    console.warn('needs login => redirecting to /login');
    return next('/login');
  }

  // Einstellungen fehlen + nicht auf Einstellungen => auf Einstellungen weiterleiten
  if (applicationState.blockedBySettings && to.name !== 'settings' && to.name !== 'login') {
    console.warn('needs settings => redirecting to /settings');
    return next('/settings');
  }

  applicationState.updateRoute(to);
  next();
});

export default router;
